import App from "../../../vendor_core/core/src/App";
import { Commands } from '../../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from '../../../vendor_core/core/src/commands/CommandManager';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import AutoplayModel from '../../../vendor_core/core/src/model/AutoplayModel';
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import BuyFeatureModel from "../../../vendor_core/core/src/model/BuyFeatureModel";
import ErrorModel from "../../../vendor_core/core/src/model/ErrorModel";
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { OverlayType } from '../../../vendor_core/core/src/server/data/ISpinData';
import { Tween } from "../../../vendor_core/core/src/Tween";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import { UIUpdateEvent } from "../../../vendor_core/core/src/ui/UIUpdateEvents";
import Layer from "../../../vendor_core/core/src/utils/Layer";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import Button from "../../../vendor_core/core/src/views/components/Button";
import PercentScalableSceneView from "../../../vendor_core/core/src/views/PercentScalableSceneView";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import VendorModel from "../../../vendor_core/src/model/VendorModel";
import VendorSpinStartState from "../../../vendor_core/src/states/VendorSpinStartState";
import Configs from "../../../vendor_core/src/vendorConfigs/Configs";

export default class VOESpinStartState extends VendorSpinStartState {
    private freegamesLayer: Layer;
    private freespinsLayer: Layer;
    private freeSpinsSpinDelay: number = 0.5;
    private cancelFreeGamesButton: Button;
    private allReelsStarted: boolean = false;
    private hasResponse: boolean = false;
    private exitDelayTween: Tween = null;

    public enter(): void {
        if (AutoplayModel.isAutoSpinActive()) {
            if(!SpinModel.isInFreespins()) {
                UIController.setMode(UIStates.AUTO);
                UIController.setState(UIStates.AUTO);
            }
        } else {
            UIController.setState(UIStates.SPIN);
        }
        this.allReelsStarted = false;
        this.hasResponse = false;
        ReelGroup.instance.once(
            GameEvents.ALL_REELS_STARTED,
            () => {
                this.allReelsStarted = true;
                this.exit()
            },
            this
        );
        this.playSymbolFadeAnim()
            .then(() => { super.enter(); });

    }

    private playSymbolFadeAnim(): Promise<boolean> {
        return new Promise<boolean>((res) => {
            let delay: number = 0;
            if (SpinModel.winAmount > 0) {
                let reelGroup = ReelGroup.instance;
                // fade anim depend on other anim, and it duration is 1sec, but actualy anim is 0.16
                // that's why I set it manually on 0.2
                // delay = reelGroup.getSymbolAt(0,0).spineAnim.getAnimDuration("fade");
                delay = 0.2;
                reelGroup.reels.forEach(reel => {
                    reel.symbols.forEach(sym => {
                        if (sym.id !== 14) {
                            sym.playAnimation("fade");
                        }
                    });
                });
                this.showStickyWildBurningAnim(reelGroup);
            }
            // Add delay between spin only in Bonus free spins game and non turbo mode!
            if (SpinModel.isInFreespins() && !GameModel.turboSpin) {
                delay += this.freeSpinsSpinDelay;
            }
            Tween.delayedCall(delay, () => {
               res(true);
            });
        });
    }

    private showStickyWildBurningAnim = (reelGroup: ReelGroup) => {
        if (SpinModel.isInFreespins()) {
            const overlay = SpinModel.getOverlay(OverlayType.Locked);
                overlay?.symbolPosition?.forEach((r, ri) => {
                    r.forEach((c, ci) => {
                        if (c) {
                            const anim = reelGroup.winSymbolsView.getAnimAtReelCell(ri, ci);
                            anim.showAnim(c, "wild_burn_loop");
                        }
                    })
                })
        }
    }

    startSpin() {
        if(App.config.symbolBlur) {
            const scene = ViewManager.getLayer(
                DefaultLayers.Reels
            ).getCurrentScene();
        }
        ReelGroup.instance.winSymbolsView.stopAll();
        this.freegamesLayer = ViewManager.getLayer(DefaultLayers.FreegamesCounter);
        this.freespinsLayer = ViewManager.getLayer(DefaultLayers.FreespinCounter);

        // Free games check first, then free spins.
        if(SpinModel.inFreegames()) {
            this.freegamesLayer.setScene("open");
            const freeGamesView = ViewManager.getLayer(DefaultLayers.FreegamesCounter).children[0] as PercentScalableSceneView;
            let counter = freeGamesView?.sceneTextFields.get("fg_counter");
            counter.text = (VendorModel.freeGames.spins -1) + "/" + (VendorModel.freeGames.spins + VendorModel.freeGames.spinsPlayed);
            this.cancelFreeGamesButton = freeGamesView.buttons.get("cancel_fg");
            let fg_cancelVisible = true;
            // imsFreespins is special for BET 365
            // https://docs.relax-gaming.com/partners/portal/operator-integrations#bet365
            if (VendorModel.freeGames.imsFreespins) {
                fg_cancelVisible = false;
            }
            this.cancelFreeGamesButton?.setVisible(fg_cancelVisible);

            // Will be disabled, while we wait for response from the server.
            this.cancelFreeGamesButton?.setEnabled(false);

        } else {
            this.freegamesLayer.clear();
        }

        if (!SpinModel.isInFreespins()) {
            this.freespinsLayer.clear();
        }

        if (this.freegamesLayer.getCurrentScene()) {
            ViewManager.getLayer(DefaultLayers.FreegamesCounter).getCurrentScene().groups.get("fg_plate").visible = !SpinModel.isInFreespins();
        }

        // super.startSpin();
        // This is copy from vendor state !!!
        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        reelGroup.disableSwipeSpin();

        // This is copy from core state !!!

        // In free spins usually we start with some accumulated win,
        // so we mustn't clear it.
        // if (!SpinModel.isInFreespins()) {
        //     SpinModel.accumulatedWin = 0;
        // }

        if (SpinModel.inFreegames()) {
            // TODO: remove this code! Never assign SpinModel data directly!
            // Also: VendorModel is placed at vendor_core, not at core!!!
            SpinModel.accumulatedWin = VendorModel.freeGames.win;
            CommandManager.execute(Commands.UPDATE_WIN, VendorModel.freeGames);
        }

        if (AutoplayModel.hasAutospinStarted()) {
            App.timeline.add(Tween.delayedCall(App.config.autoSpinDelay, () => {
                // Here is the update in condition for clean win command (don't need clean win in free spins)
                if (!SpinModel.inFreegames() && !SpinModel.isInFreespins() && !SpinModel.isInRespins()) {
                    CommandManager.execute(Commands.CLEAR_WIN);
                }

                this.initReel();
                this.sendRequest();
            }), App.timeline.time);
        } else {
            this.initReel();
            this.sendRequest();
        }
        // SoundController.playSound(SoundVars.EFFECT_REEL_SPIN, true, 1);
        App.dispatcher.emit(GameEvents.START_SPIN);
        App.dispatcher.emit(GameEvents.LINES_BOX_UPDATE);

    }

    protected hasExtraPermission(): boolean {
        return BuyFeatureModel.hasBuyFeatureIsTriggered || BuyFeatureModel.isInBuyFeatureFreeSpins;
    }

    protected makeBet() {
        // if we have activated buy feature spin
        // substracted bet must be different
        const hasBuyFeatSpin = BuyFeatureModel.hasBuyFeatureIsTriggered || BuyFeatureModel.isInBuyFeatureFreeSpins;
        BetModel.subtractBet(hasBuyFeatSpin
            ? Configs.buyFeature.betMultiplier[BuyFeatureModel.mode] * BuyFeatureModel.validBets[BuyFeatureModel.currentBetIndex]
            : BetModel.totalBet);
        UIController.updateFields(UIUpdateEvent.Balance);
    }

    protected onResponse(data?: any): void {
        this.hasResponse = true;
        super.onResponse(data);
        this.cancelFreeGamesButton?.setEnabled(!(SpinModel.hasFreespinsWon() || SpinModel.isInFreespins()));
    }

    protected isMinSpinTimePassed(): boolean {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        return reelGroup.getSpinTimePassed() > this.getMinTimeInState()
    }

    // Return min time that we must stay in spin start state and reels is spinning in ms
    public getMinTimeInState(): number {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        let result = 0;
        result = (App.config.minSpinTime * 1000) - reelGroup.getSpinStopTime();

        if (result < 0) {
            result = 0;
        }

        return result
    }



    // Delay time to call exit() in seconds
    protected getMinSpinTimeExitDelay(): number {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        let delay = this.getMinTimeInState() - reelGroup.getSpinTimePassed();
        if (delay < 0) {
            delay = 0
        } else {
            delay = delay / 1000;
        }

        return delay
    }

    public exit(): void {
        if ((this.allReelsStarted && this.hasResponse) || ErrorModel?.errorCode > 0) {
            if (this.isMinSpinTimePassed()) {
                this.allReelsStarted = false;
                this.hasResponse = false;
                super.exit();
            } else {
                this.exitDelayTween?.kill();
                this.exitDelayTween = Tween.delayedCall(this.getMinSpinTimeExitDelay(), () => this.exit());
            }
        }
    }
}
